module.exports = __webpack_public_path__ + "media/images/1200/weight_loss_bed-21674264b125478fed79b474afda548b.jpg";